import { usePosterContext } from "../../../../context/poster-context";
import {
  MainInfoSectionWrapper,
  MainInfoSectionItem,
  MainInfoWrapper,
  MainInfoContentItemInput,
  MainInfoHeaderItem,
  MainInfoHeader,
  MainInfoContentWrapper,
  MainInfoContentItem,
} from "../main-info/styles/main-info.style";

const PrizePool = () => {
  const {
    prizePoolSection,
    setPrizePoolSection,
    prizePool,
    setPrizePool,
    prizePoolFontSize,
    setPrizePoolFontSize,
  } = usePosterContext();

  const getRankType = (index: number) => {
    return index === 0 ? "st" : index === 1 ? "nd" : index === 2 ? "rd" : "th";
  };

  const handleAddPrizePool = () => {
    setPrizePool([
      ...prizePool,
      {
        isShow: true,
        rank: (prizePool.length + 1).toString() + getRankType(prizePool.length),
        prize: "",
      },
    ]);
  };

  const handleRemovePrizePool = () => {
    setPrizePool(prizePool.slice(0, -1));
  };

  const handleChangePrize = (index: number, value: string) => {
    const newPrizePool = [...prizePool];
    newPrizePool[index].prize = value;
    setPrizePool(newPrizePool);
  };

  const handleChangeRank = (index: number, value: string) => {
    const newPrizePool = [...prizePool];
    newPrizePool[index].rank = value;
    setPrizePool(newPrizePool);
  };

  return (
    <MainInfoWrapper>
      <MainInfoSectionWrapper>
        <MainInfoSectionItem>
          <div className="label">섹션명</div>
          <MainInfoContentItemInput
            value={prizePoolSection}
            onChange={(e) => {
              setPrizePoolSection(e.target.value);
            }}
          />
        </MainInfoSectionItem>
        <MainInfoSectionItem>
          <div className="label">순위 설정</div>
          <img
            src="/image-web/poster/minus.svg"
            alt="minus"
            onClick={handleRemovePrizePool}
          />
          <div className="font-size">{prizePool.length}</div>
          <img
            src="/image-web/poster/plus.svg"
            alt="plus"
            onClick={handleAddPrizePool}
          />
        </MainInfoSectionItem>
        <MainInfoSectionItem>
          <div className="label">폰트 크기</div>
          <img
            src="/image-web/poster/minus.svg"
            alt="minus"
            onClick={() => {
              if (prizePoolFontSize > 1) {
                setPrizePoolFontSize(prizePoolFontSize - 1);
              }
            }}
          />
          <div className="font-size">{prizePoolFontSize}</div>
          <img
            src="/image-web/poster/plus.svg"
            alt="plus"
            onClick={() => {
              setPrizePoolFontSize(prizePoolFontSize + 1);
            }}
          />
        </MainInfoSectionItem>
      </MainInfoSectionWrapper>
      <MainInfoHeader>
        <MainInfoHeaderItem flex={1}>항목</MainInfoHeaderItem>
        <MainInfoHeaderItem flex={1}>내용 </MainInfoHeaderItem>
      </MainInfoHeader>
      {prizePool.map((item, index) => (
        <MainInfoContentWrapper key={index}>
          <MainInfoContentItem flex={1}>
            <MainInfoContentItemInput
              value={item.rank}
              onChange={(e) => handleChangeRank(index, e.target.value)}
            />
          </MainInfoContentItem>
          <MainInfoContentItem flex={1} style={{ marginLeft: "10px" }}>
            <MainInfoContentItemInput
              value={item.prize}
              onChange={(e) => handleChangePrize(index, e.target.value)}
            />
          </MainInfoContentItem>
        </MainInfoContentWrapper>
      ))}
    </MainInfoWrapper>
  );
};

export default PrizePool;
